import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import {
  MapControlsWrapper,
  StyledCheckbox,
  MapControlsRow,
  MapControlsText,
} from './ReviewModal.styles';

const MapControlsJBoundary = ({ mapControls, handleMapControlChange }) => {
  return (
    <MapControlsWrapper>
      <Box flow={10}>
        <MapControlsRow>
          <StyledCheckbox
            name="submittedPolygon"
            checked={mapControls.submittedPolygon}
            onChange={handleMapControlChange}
          />
          <MapControlsText>
            My Jurisdictional Boundary
            <br />
            (Jurisdiction View)
          </MapControlsText>
        </MapControlsRow>
        <MapControlsRow>
          <StyledCheckbox
            name="processedPolygon"
            checked={mapControls.processedPolygon}
            onChange={handleMapControlChange}
          />
          <MapControlsText>
            Edited Jurisdictional Boundary
            <br />
            (Jurisdiction View)
          </MapControlsText>
        </MapControlsRow>
        <MapControlsRow>
          <StyledCheckbox
            name="boundingBox"
            checked={mapControls.boundingBox}
            onChange={handleMapControlChange}
          />
          <MapControlsText>My geofence</MapControlsText>
        </MapControlsRow>
      </Box>
    </MapControlsWrapper>
  );
};

export default MapControlsJBoundary;
